import { ATSInviteToApplyTestIds } from 'data-testids/ATS';
import { CTAButtonContainer, Key, SubContainer } from '../styles/hiringRequestStyles';
import { PrimaryButton } from 'sharedComponents/Buttons';
import { useHistory } from 'react-router';

export const InviteToApplyExistingAppDisplay: React.FC = () => {
  const history = useHistory();

  return (
    <>
      <SubContainer data-testid={ATSInviteToApplyTestIds.EXISTING_APP_SECTION}>
        <Key data-testid={ATSInviteToApplyTestIds.EXISTING_APP_TITLE}>
          This candidate already has an application for this role. To view all candidates for this
          role, click below.
        </Key>
      </SubContainer>
      <CTAButtonContainer>
        <PrimaryButton
          dataTestId={ATSInviteToApplyTestIds.VIEW_CANDIDATES_BUTTON}
          onClick={() => history.push('/principal/candidates')}
        >
          View All Candidates
        </PrimaryButton>
      </CTAButtonContainer>
    </>
  );
};
